import HttpClient from "../httpClient";
import { StationCameraItem, StationCameraFilter } from "../../models/types/stationCamera";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class StationCameraService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<StationCameraFilter>): Promise<DefaultResponseContent<StationCameraItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StationCameraItem[]>>("/admin/StationCamera/GetAll", requestData);
        return response;
    }

    async getStationCameraById(id: string): Promise<DefaultResponse<StationCameraItem>> {
        const response = await this.service.get<DefaultResponse<StationCameraItem>>(`/admin/StationCamera/GetDetail/${id}`);
        return response;
    }

    async createStationCamera(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationCamera/Create`, requestData);
        return response;
    }

    async updateStationCamera(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationCamera/Update`, requestData);
        return response;
    }

    async deleteStationCamera(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/StationCamera/Delete/${id}`);
        return response;
    }

}

const stationCameraSvc = new StationCameraService();
export default stationCameraSvc;
